import { GroupMeta } from '../meta.model';
import { User } from '..';

export interface GroupViewModel {
  id: number;
  name: string;
  externalId: string;
  expectedCount: number;
  language: string;
  isPin: boolean;
  companyId: number;
  categoryId: number;
  conditionId: number;
  meta: GroupMeta[];
  managers: User[];
}

export interface EditGroup {
  id: number;
  name: string;
  externalId: string;
  companyId: number;
  ruleId?: number;
  attributes: GroupAttribute[];
  categoryId: number;
  managers?: User[];
  conditionId?: number;
  managerHandledByRule: boolean;
  hideExternalId: boolean;
  isPin: boolean;
}

/** attributeId used by the system for the group's team identifier. */
export const TEAM_ID_ATTRIBUTE = 2;

export interface GroupAttribute {
  attributeId: number;
  attributeName: string;
  value: string;
  values: any;
  valuesWithNames: any;
  connectedToUserField: string;
  connectedToBaseGroup?: number;
}
